import Updates from './Updates.vue';
import PluginsAndThemes from './PluginsAndThemes.vue';
import ActivityLog from './ActivityLog.vue';
import LoginActivity from './LoginActivity.vue';
import backups from './backups.vue';
import addons from './addons.vue';
export default {
  updates: Updates,
  pluginsAndThemes: PluginsAndThemes,
  activityLog: ActivityLog,
  loginActivity: LoginActivity,
  backups,
  addons
};
